import { gql } from "@apollo/client";

const ADD_DEAL = gql`
  mutation addDeal($dealInput: DealInput!){   
    addDeal(dealInput: $dealInput)
  }`
;

export default ADD_DEAL;
